//新看板--维护中设备数量
import React, { Component } from "react";
import PropTypes from "prop-types";
import fetchHandler from "@/fetch/fetchHandler";
import { queryMaintainEquipments } from "@/fetch/fetchApi";
import { initModals } from "@/state/action/comAction";
import ModalMulterCore from "@/components/feedback/scModalMulterCore";
import MaintenanceDevicesDetail from "./maintenanceDevicesDetail";
import {
  RightOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  SettingOutlined,
} from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Empty } from "antd";
import "@/assets/stylus/displayBoard.styl";

@connect((state) => state)
class MaintenanceDevices extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    const param = this.props.param || {};
    this.state = {
      totalCount: 14362,
      compareRate: -1.3,
      param: {
        cityIds: param.cityIds || "",
        provinceIds: param.provinceIds || "000000",
        date: param.date || "",
        isMonth: param.isMonth || 2,
        operationProperty: param.operationProperty || "3",
        operationMode: param.operationMode || "",
        endTime: param.endTime || "",
      },
      regionList: [
        // { name: "江苏省", count: 142, rate: 23.54 },
        // { name: "山东省", count: 128, rate: 21.28 },
        // { name: "北京市", count: 96, rate: 18.67 },
        // { name: "上海市", count: 73, rate: 13.22 },
        // { name: "陕西省", count: 39, rate: 7.5 },
      ],
      regionTop5List: [],
    };

    // 定义modals
    this.modalConfig = [
      {
        key: "maintenanceDevicesDetailModal",
        width: 800, // 自定义模态框宽度
        title: "维护中设备分布", // 模态窗口的标题
        content: MaintenanceDevicesDetail, // 自定义 jsx内容
      },
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  getMaintainEquipments() {
    const { date, startTime, endTime } = this.state.param;
    fetchHandler(queryMaintainEquipments, {
      startTime: this.state.param.isMonth === 3 ? startTime : date,
      endTime: endTime,
      cityIds: this.state.param.cityIds,
      isMonth: this.state.param.isMonth,
      stubType: this.state.param.stubType,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        const provinceEquipmentMaintainQuantityDTOS =
          res.data.provinceEquipmentMaintainQuantityDTOS;
        // lockStatusNumDTOList为null时，设置lockStatusData为空数组，并标记noData为true
        if (provinceEquipmentMaintainQuantityDTOS === null) {
          this.setState({
            regionList: [],
            regionTop5List: [],
            totalCount: 0,
            compareRate: 0,
          });
          return;
        }
        this.setState({
          regionList: provinceEquipmentMaintainQuantityDTOS,
          regionTop5List: provinceEquipmentMaintainQuantityDTOS.slice(0, 5),
          totalCount: res.data.totalNum,
          compareRate: res.data.sequential,
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    console.log("componentWillReceiveProps****device***nextProps", nextProps);

    const nextParam = nextProps.param || {};
    const currentParam = this.state.param || {};
    if (
      nextParam.provinceIds === currentParam.provinceIds &&
      nextParam.cityIds === currentParam.cityIds &&
      nextParam.stubType === currentParam.stubType &&
      nextParam.isMonth === currentParam.isMonth &&
      nextParam.operationProperty === currentParam.operationProperty &&
      nextParam.operationMode === currentParam.operationMode &&
      nextParam.date === currentParam.date &&
      nextProps.param.startTime === this.state.param.startTime &&
      nextProps.param.endTime === this.state.param.endTime
    ) {
      return;
    }
    this.setState(
      {
        param: {
          isMonth: nextParam.isMonth || 2,
          cityIds: nextParam.cityIds || "",
          provinceIds: nextParam.provinceIds || "000000",
          date: nextParam.date || "",
          operationProperty: nextParam.operationProperty || "3",
          operationMode: nextParam.operationMode || void 0,
          stubType: nextParam.stubType || void 0,
          startTime: nextParam.startTime,
          endTime: nextParam.endTime,
        },
        loading: true,
      },
      () => {
        this.getMaintainEquipments();
      },
    );
  }

  componentDidMount() {
    this.getMaintainEquipments();
  }

  render() {
    return (
      <div className="item" style={{ paddingLeft: "12px" }}>
        <div className="inner" style={{ height: "621px", marginRight: 0 }}>
          <div className="title">
            <div className="title-name">维护中设备数量</div>
            <div
              className="title-more"
              // onClick={() => {
              //   // this.openTab(
              //   //   {
              //   //     paramInfo: this.state.param,
              //   //   },
              //   //   {
              //   //     key: "030101",
              //   //     titleText: "设备完好率",
              //   //   },
              //   // );
              // }}
              onClick={(e) => {
                console.log("点击详情", e);
                this.context.store.dispatch(
                  initModals("maintenanceDevicesDetailModal", {
                    dataSource: this.state.regionList,
                    totalCount: this.state.totalCount,
                  }),
                );
              }}>
              {" "}
              详情
              <RightOutlined />{" "}
            </div>
          </div>
          <div className="maintenance-devices">
            <div className="header-part">
              <div className="icon-box">
                <SettingOutlined className="wrench-icon" />
              </div>
              <div className="info-box">
                <div className="label">充电枪数(台)</div>
                <div className="count">{this.state.totalCount.toLocaleString()}</div>
              </div>
              <div className="compare-box">
                <div className="compare-label">环比</div>
                <div className={`compare-rate ${this.state.compareRate < 0 ? "down" : "up"}`}>
                  {this.state.compareRate < 0 ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                  <span>{Math.abs(this.state.compareRate)}%</span>
                </div>
              </div>
            </div>
            <div className="table-header">
              <span className="col-region">地区</span>
              <span className="col-count">设备数量</span>
              <span className="col-rate">设备占比</span>
            </div>
            <div className="table-body">
              {this.state.regionTop5List.length === 0 ? (
                <Empty style={{ marginTop: 20 }} description="暂无维护中设备数据" />
              ) : (
                this.state.regionTop5List.map((item, index) => (
                  <div key={index} className="table-row">
                    <span className="col-region">{item.provinceName}</span>
                    <span className="col-count">{item.num}</span>
                    <div className="col-rate-wrapper">
                      <span className="rate-text">{item.rate}%</span>
                      <div className="progress-bar">
                        <div className="progress-fill" style={{ width: `${item.rate}%` }}></div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
      </div>
    );
  }
}

export default injectIntl(MaintenanceDevices);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/maintenanceDevices.js